import { GameVars } from "../../GameVars";
import { Cell } from "./Cell";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

export class BoardContainer extends Phaser.Group {
   
    public static currentInstance: BoardContainer;

    private cells: Cell[][];

    constructor(game: Phaser.Game) {

        super(game, null, "board-container");

        BoardContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2 + GameConstants.CELL_SIZE / 2;
        this.y = GameConstants.GAME_HEIGHT / 2 + 90 * GameVars.scaleY;

        let s: number;

        switch (GameVars.difficulty) {
            case GameConstants.DIFFICULTY_EASY:
                this.x += GameConstants.CELL_SIZE * .075;
                s = GameConstants.BOARD_SCALE_BEGINNER;
                break;
            case GameConstants.DIFFICULTY_MEDIUM:
                s = GameConstants.BOARD_SCALE_INTERMEDIATE;
                break;
            case GameConstants.DIFFICULTY_HARD:
                this.x -= GameConstants.CELL_SIZE * .075;
                s = GameConstants.BOARD_SCALE_EXPERT;
                break;
            default:
        }

        this.scale.set(s, s * GameVars.scaleY);

        this.cells = [];

        for (let r = 0; r < GameVars.boardSize.r; r++) {

            this.cells[r] = [];

            for (let c = 0; c < GameVars.boardSize.c; c++) {

                const cell = new Cell(this.game, {r: r, c: c });
                this.add(cell);

                this.cells[r][c] = cell;
            }
        }
    }

    public start(): void {

        for (let r = 0; r < GameVars.boardSize.r; r++) {
            for (let c = 0; c < GameVars.boardSize.c; c++) {
                this.cells[r][c].start();
            }
        }
    }

    public flagCell(p: { r: number, c: number }): void {

        this.cells[p.r][p.c].flag();
    }

    public unFlagCell(p: { r: number, c: number }): void {

        this.cells[p.r][p.c].unFlag();
    }

    public revealOpenedCells(): void {

        for (let r = 0; r < GameVars.boardSize.r; r++) {
            for (let c = 0; c < GameVars.boardSize.c; c++) {

                if (GameVars.grid[r][c].state === GameVars.minesweeper.CellStateEnum.OPEN && !this.cells[r][c].opened) {
                    this.cells[r][c].open();
                }
            }
        }

        AudioManager.playSound("cell_flip_reveal");
    }

    public revealMinedCells(p: {r: number, c: number}): void {

        for (let r = 0; r < GameVars.boardSize.r; r++) {
            for (let c = 0; c < GameVars.boardSize.c; c++) {

                if (GameVars.grid[r][c].isMine) {
                    this.cells[r][c].open();

                    if (r === p.r && c === p.c) {
                        this.bringToTop(this.cells[r][c]);
                        this.cells[r][c].explode();
                    }
                }
            }
        }
    }

    public hideFlags(): void {

        for (let r = 0; r < GameVars.boardSize.r; r++) {
            for (let c = 0; c < GameVars.boardSize.c; c++) {

                this.cells[r][c].unFlag();
            }
        }
    }

    public checkSurroundingCells(sourroundingCellsIndexes: { r: number; c: number}[]): void {

        for (let i = 0; i < sourroundingCellsIndexes.length; i ++) {

            const r = sourroundingCellsIndexes[i].r;
            const c = sourroundingCellsIndexes[i].c;

            const cell = GameVars.grid[r][c];
            
            if (cell.state === GameConstants.BOARD_STATE_PRISTINE) {
                this.cells[r][c].check();
            }
        }
    }

    public uncheckSurroundingCells(sourroundingCellsIndexes: { r: number; c: number}[]): void {

        for (let i = 0; i < sourroundingCellsIndexes.length; i ++) {

            const r = sourroundingCellsIndexes[i].r;
            const c = sourroundingCellsIndexes[i].c;

            const cell = GameVars.grid[r][c];
            
            if (cell.state === GameConstants.BOARD_STATE_PRISTINE) {
                this.cells[r][c].uncheck();
            }
        }
    }   
}
